import { render, staticRenderFns } from "./StanleyChatVisual.vue?vue&type=template&id=140e8ec4&scoped=true"
import script from "./StanleyChatVisual.vue?vue&type=script&lang=js"
export * from "./StanleyChatVisual.vue?vue&type=script&lang=js"
import style0 from "./StanleyChatVisual.vue?vue&type=style&index=0&id=140e8ec4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "140e8ec4",
  null
  
)

export default component.exports